var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-search-input"},[_c('input',{staticClass:"form-control",class:{ 'is-invalid': _vm.invalid },attrs:{"type":_vm.type,"id":_vm.id,"disabled":_vm.disabled,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.onInput}})])
}
var staticRenderFns = []

export { render, staticRenderFns }